import React, { useEffect } from 'react';
import './Projects.css';
import Aos from "aos";
import "aos/dist/aos.css";
import jalsadhnaImg from '../jalsadhna.png';
import trademarkguruImg from '../trademarkguru.png';
import portfolioImg from '../portfolio.png';

const projects = [
  {
    title: "Jal Shakti Jalsadhna",
    description: "An AI-driven chatbot for groundwater management utilizing NLP and machine learning. Features real-time insights on groundwater levels, hydrogeological conditions, and water quality.",
    technologies: ["Python", "Groq", "FastAPI", "LLM", "RAG", "NLP"],
    image: jalsadhnaImg,
    liveLink: "https://jal-shakti-jalsadhna.onrender.com",
    githubLink: "https://github.com/mridulgoel03/Jal-Shakti-Jalsadhna-SIH-2023",
    category: "AI/ML"
  },
  {
    title: "Sakha - Emotion Detection System",
    description: "An AI-driven chatbot that detects and responds to user emotions in real-time using facial expressions and voice commands, achieving 85% accuracy.",
    technologies: ["OpenAI API", "FER", "SpeechRecognition", "Streamlit", "OpenCV"],
    image: "", // Placeholder
    liveLink: "https://github.com/mridulgoel03/Sakha-Emotion-Detection-System#readme",
    githubLink: "https://github.com/mridulgoel03/Sakha-Emotion-Detection-System",
    category: "AI/ML"
  },
  {
    title: "Trademark Guru",
    description: "A cutting-edge dApp for seamless trademark registration on the Edu Chain Testnet, created for a hackathon.",
    technologies: ["Blockchain", "React", "Solidity"],
    image: trademarkguruImg,
    liveLink: "https://trademark-guru.vercel.app/",
    githubLink: "https://github.com/mridulgoel03/Trademark-Guru",
    category: "Web3"
  },
  {
    title: "Income GPT",
    description: "An AI-powered CLI tool that generates personalized business ideas based on user inputs by analyzing market trends.",
    technologies: ["Python", "OpenAI API", "Poetry", "CLI"],
    image: "", // Placeholder
    liveLink: "https://github.com/mridulgoel03/income-gpt#readme",
    githubLink: "https://github.com/mridulgoel03/income-gpt",
    category: "AI/ML"
  },
    {
    title: "This Portfolio",
    description: "The responsive portfolio website you're currently viewing, built with React.",
    technologies: ["React", "CSS", "Bootstrap"],
    image: portfolioImg,
    liveLink: "#",
    githubLink: "https://github.com/mridulgoel03/Mridul-Portfolio",
    category: "Web"
  },
];

function Projects() {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  return (
    <div id="projects" className="container-fluid">
      <h2 className="topic-head">Things I've Built</h2>
      <div className="projects-grid">
        {projects.map((project, index) => (
          <div className="project-card" key={index} data-aos="fade-up" data-aos-once="true">
            <div className="project-image">
              {project.image ? <img src={project.image} alt={project.title} /> : <div className="image-placeholder"></div>}
            </div>
            <div className="project-content">
              <h3 className="project-title">{project.title}</h3>
              <p className="project-description">{project.description}</p>
              <ul className="project-technologies">
                {project.technologies.map(tech => <li key={tech}>{tech}</li>)}
              </ul>
              <div className="project-links">
                {project.githubLink && <a href={project.githubLink} target="_blank" rel="noopener noreferrer"><i className="fab fa-github"></i></a>}
                {project.liveLink && <a href={project.liveLink} target="_blank" rel="noopener noreferrer"><i className="fas fa-external-link-alt"></i></a>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Projects;
